<template>
  <div>
    <h2 class="text-left alert" :class="[ removed ? 'alert-danger' : 'alert-success' ]">
      Review Reproduction
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[ removed ? 'glyphicon-plus' : 'glyphicon-remove' ]"></span>
      </a>
    </h2>

    <template v-if="!removed">
      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('cows_wintered_metrichecked') ? 'subsection-disabled' : ''">
          <u> % cows wintered that were Metrichecked/Metricleaned</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'cows_wintered_metrichecked')">
            <span class="glyphicon" :class="isRemovedSubsection('cows_wintered_metrichecked') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Percent of CW Metrichecked</th>
              <th>Region Avg. Percent of CW Metrichecked</th>
              <th>Percent Metricleaned of Metrichecked</th>
              <th>Region Avg. Percent Metricleaned of Metrichecked</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, index) in model.CHARTS.metri_checked_cleaned" :key="index"
              :class="getRowClass(model.CHARTS.metri_checked_cleaned, 'Season', index)">

              <td class="text-left">{{ rv["Season"] }}</td>
              <td class="text-left">{{ rv["Percent of CW Metrichecked"] }}</td>
              <td class="text-left">{{ rv["Region Avg. Percent of CW Metrichecked"] }}</td>
              <td class="text-left">{{ rv["Percent Metricleaned of Metrichecked"] }}</td>
              <td class="text-left">{{ rv["Region Avg. Percent Metricleaned of Metrichecked"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <bar :chart-data="metriCheckedCleanedChartData" :options="defaultChartOptions" ref="metrichecked_chart"></bar>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('metri_checked_cleaned_table') ? 'subsection-disabled' : ''">
          <u>Dairy Metricheck/Metriclean Purchases</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'metri_checked_cleaned_table')">
            <span class="glyphicon" :class="isRemovedSubsection('metri_checked_cleaned_table') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Season</th>
              <th>Date</th>
              <th>Product</th>
              <th>Cows</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(rv, index) in model.CHARTS.sr_metri_checked_cleaned_table" :key="index"
              :class="getRowClass(model.CHARTS.sr_metri_checked_cleaned_table, 'Season', index)">

              <td class="text-left">{{ rv["Season"] }}</td>
              <td class="text-left">{{ rv["Date"] }}</td>
              <td class="text-left">{{ rv["Product"] }}</td>
              <td class="text-left">{{ rv["Cows"] }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('dairy_cow_non_cycling_exams') ? 'subsection-disabled' : ''">
          <u> Dairy cow non—cycling examinations as a percentage of total cows wintered </u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'dairy_cow_non_cycling_exams')">
            <span class="glyphicon" :class="isRemovedSubsection('dairy_cow_non_cycling_exams') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <bar :chart-data="nonCyclingChartData" :options="defaultChartOptions" ref="noncycling_chart"></bar>
        <p class="text-center">Previous seasons period 1st Oct – 31st Dec, current season 1st Oct – YTD</p>
      </div>

      <div class="text-left step-section">
        <h3 :class="isRemovedSubsection('cuemate_cidr_cows_treated') ? 'subsection-disabled' : ''">
          <u>CIDR cows treated as a percent of total cows wintered</u>
          <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName, 'cuemate_cidr_cows_treated')">
            <span class="glyphicon" :class="isRemovedSubsection('cuemate_cidr_cows_treated') ? 'glyphicon-plus' : 'glyphicon-remove'">
            </span>
          </a>
        </h3>
        <bar :chart-data="cuemateChartData" :options="defaultChartOptions" ref="cuemate_chart"></bar>
        <p class="text-center">Previous seasons period 1st Oct – 31st Dec, current season 1st Oct – YTD</p>
      </div>

      <div class="text-left step-section">
        <dl class="dl-horizontal">
          <dt>Key Points</dt>
          <dd>{{ model.repro_keypoints || '-'}}</dd>

          <dt>Actions</dt>
          <dd>{{ model.repro_actions || '-'}}</dd>
        </dl>
      </div>
    </template>
  </div>
</template>

<script>
import mixin from './mixin'
import Bar from '../../charts/Bar'

export default {
  mixins: [ mixin ],
  props: ['model'],
  components: {
    Bar,
  },
  data() {
    return {
      stepName: 'ReviewReproduction',
    }
  },
  computed: {
    defaultChartOptions: function () {
      return {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: 'Percent of CW',
            }
          }]
        }
      }
    },
    cuemateChartData: function () {
      return {
        labels: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Percent treated of CW']).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.cuemate_cidr_treated.map(row => row['Region Avg. Percent treated of CW']).reverse(),
          },
        ],
      }
    },
    nonCyclingChartData: function() {
      return {
        labels: this.model.CHARTS.non_cycling_exam.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "This Farm",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.non_cycling_exam.map(row => row['Percent examined of CW']).reverse(),
          },
          {
            label: "Region",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.non_cycling_exam.map(row => row['Region Avg. Percent examined of CW']).reverse(),
          },
        ],
      }
    },
    metriCheckedCleanedChartData: function() {
      return {
        labels: this.model.CHARTS.metri_checked_cleaned.map(row => row['Season']).reverse(),
        datasets: [
          {
            label: "Percent of CW Metrichecked",
            backgroundColor:  "#3e95cd",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Percent of CW Metrichecked']).reverse(),
          },
          {
            label: "Percent Metricleaned of Metrichecked",
            backgroundColor:  "#c45850",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Percent Metricleaned of Metrichecked']).reverse(),
          },
          {
            label: "Region Avg. Percent of CW Metrichecked",
            backgroundColor:  "#ADFF2F",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Region Avg. Percent of CW Metrichecked']).reverse(),
          },
          {
            label: "Region Avg. Percent Metricleaned of Metrichecked",
            backgroundColor:  "#008000",
            data: this.model.CHARTS.metri_checked_cleaned.map(row => row['Region Avg. Percent Metricleaned of Metrichecked']).reverse(),
          },
        ],
      }
    },
  },
};
</script>
